import { FC, useCallback } from 'react';
import {
  Email,
  FacebookRounded,
  Instagram,
  LaptopOutlined,
  LocationOn,
  Phone,
  Twitter,
  YouTube,
} from '@mui/icons-material';
import { Footer } from './footer';
import { LinkListProps } from '../../components/link-list/link-list';
import { IMidia } from '../../components/social-midia/social-midia';
import { useHistory } from 'react-router-dom';
import { useWebgate } from '@xvia/webgate-connect';

export const FooterContainer: FC = () => {
  const social: IMidia[] = [
    { Icon: Instagram, link: 'https://instagram.com/governoes' },
    { Icon: FacebookRounded, link: 'https://facebook.com/governoes' },
    { Icon: YouTube, link: 'https://youtube.com/governoes' },
    { Icon: Twitter, link: 'https://twitter.com/governoes' },
  ];

  const lists: LinkListProps[] = [
    {
      title: 'Início',
      Icon: LaptopOutlined,
      linkList: [
        {
          text: 'Início',
          link: '/app/catalog',
        },
        {
          text: 'Órgãos e Secretarias',
          link: '/app/catalog/orgaos-e-secretarias',
        },
        {
          text: 'Políticas de Privacidade',
          link: '/app/catalog/politicas-de-privacidade',
        },
      ],
    },
    {
      title: 'Serviços',
      Icon: LaptopOutlined,
      linkList: [
        {
          text: 'Serviços Disponíveis',
          link: '/app/catalog/carta-de-servicos',
        },
        {
          text: 'Notícias',
          link: '/app/catalog/noticias',
        },
      ],
    },
  ];

  const contacts = [
    {
      Icon: Phone,
      text: '+55 (27) 3636-1024',
    },
    {
      Icon: LocationOn,
      text: 'Praça João Clímaco, 142 - Cidade Alta, Centro, Vitória/ES - CEP: 29015-110',
    },
    {
      Icon: Email,
      text: 'ouvidoria@es.gov.br',
    },
  ];

  function isCatalogPath(path: string): boolean {
    return path.includes('/app/catalog') || path.startsWith('/catalog');
  }

  function normalizeCatalogPath(path: string): string {
    if (path.includes('/app/catalog')) {
      return path.replace('/app/catalog', '') || '/';
    }
    if (path.startsWith('/catalog')) {
      return path.replace('/catalog', '') || '/';
    }
    return path;
  }

  const history = useHistory();
  const { portalConnect } = useWebgate();

  const handleLinkClick = useCallback(
    (
      e: React.MouseEvent<HTMLAnchorElement>,
      link: string,
      isExternal?: boolean
    ) => {
      if (isExternal) {
        return;
      }

      e.preventDefault();

      if (isCatalogPath(link)) {
        const internalPath = normalizeCatalogPath(link);
        history.push(internalPath);
        return;
      }

      if (link.startsWith('/app/') || link.startsWith('/')) {
        if (portalConnect?.redirectTo) {
          portalConnect.redirectTo(link);
        }

        window.location.href = link;
        return;
      }

      window.location.href = link;
    },
    [history, portalConnect]
  );

  return (
    <Footer
      lists={lists}
      social={social}
      contacts={contacts}
      handleLinkClick={handleLinkClick}
    />
  );
};
